/**
 * @file Confirm Dialog
 */

import * as focusTrap from 'focus-trap';
import axios from 'axios';

/**
 * Confirm Dialog component
 */
 const vConfirmDialog = () => {
    const modal = document.querySelector('.v-confirm-dialog');

    if (!modal) {
        return;
    }

    // const dialog     = modal.querySelector('.v-confirm-dialog__dialog');
    const triggers   = document.querySelectorAll('.v-confirm-trigger');
    const submitBtn  = modal.querySelector('.v-confirm-dialog__submit-btn');
    const background = modal.querySelector('.v-confirm-dialog__bg');
    const closeBtn   = modal.querySelector('.v-confirm-dialog__close-btn');
    const dialogForm   = modal.querySelector('.v-confirm-dialog__form');
    const trap       = focusTrap.createFocusTrap(modal, {
        initialFocus: modal,
        fallbackFocus: submitBtn,
    });


    /**
     * Open dialog
     */
    const openDialog = (e) => {
        e.preventDefault();
        const { target }   = e;
        const button       = target.closest('.v-confirm-trigger');
        const row          = button.closest('tr');
        const route        = button.getAttribute('data-route');
        const recordId     = button.getAttribute('data-record-id');

        dialogForm.setAttribute('action', route);
        // dialogInput.setAttribute('name', isSubmission ? 'submission_id' : 'user_id');
        dialogForm.querySelector('input[name="record_id"]').value = recordId ? recordId : '';
        modal.classList.add('is-active');

        if (row) {
            row.classList.add('is-selected');
        }

        trap.activate();
    };

    /**
     * Close dialog
     */
    const closeDialog = () => {
        const listingTable = document.querySelector('.v-list-view__table');
        const recordInput  = dialogForm.querySelector('input[name="record_id"]');
        if (listingTable) {
            const row = listingTable.querySelector('tr.is-selected');

            if (row) {
                row.classList.remove('is-selected');

                if (!row.classList.contains('is-deleting')) {
                    [...row.querySelectorAll('button')].forEach((button) => {
                        button.removeAttribute('disabled');
                    });
                }
            }
        }

        modal.classList.remove('is-active');

        dialogForm.setAttribute('action', '');
        // dialogForm.querySelector('input[name="submission_id"]').value = '';
        // recordInput.setAttribute('name', '');
        recordInput.value = '';
        trap.deactivate();
    };

    [...triggers].forEach((trigger) => {
        trigger.addEventListener('click', openDialog);
    });

    [background, closeBtn].forEach((el) => {
        el.addEventListener('click', closeDialog);
    });

    submitBtn.addEventListener('click', () => {
        const endpoint = dialogForm.getAttribute('action');
        const token    = document.querySelector('input[name="_token"]').value;

        if (submitBtn.hasAttribute('data-is-ajax')) {
            const recordId = dialogForm.querySelector('input[name="record_id"]').value;
            const listingTable = document.querySelector('.v-list-view__table');
            if (listingTable) {
                const row = listingTable.querySelector(`tr.is-selected`);

                if (row) {
                    row.classList.add('is-deleting');

                    [...row.querySelectorAll('button')].forEach((button) => {
                        button.disabled = true;
                    });
                }
            }

            closeDialog();

            const axiosInstance = axios.create({
                // baseURL: endpoint,
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            });

            // console.log(recordId, token);


            axiosInstance.post(endpoint, {
                id: recordId,
                _token: token,
            })
                .then((response) => {
                    if (response.data.success) {
                        const alert = document.querySelector('.v-alert');

                        if (alert) {
                            const alertTitle = document.querySelector('.v-alert__title');
                            alert.classList.remove('v-alert--hidden');
                            alert.classList.add('v-alert--visible');
                            alertTitle.innerHTML = response.data.message;
                            setTimeout(() => {
                                window.location.reload();
                            }, 1500);
                        } else {
                            window.location.reload();
                        }

                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            dialogForm.submit();
        }
    });
};

export default vConfirmDialog;
